<script>
export default {
    data() {
        return {
            collapsed: true
        }
    }
}
</script>

<style lang="scss">
@media (max-width: 1023px) {
    .Sidebar {
        transform: translateX(0);
        transition: transform .25s;
    }
    .Sidebar--collapsed {
        transform: translateX(-300px);
    }
}
</style>
